import FormattedMessage from 'I18n/components/FormattedMessage';
import UISelect from 'UIComponents/input/UISelect';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { isInboxHelpdesk } from 'conversations-internal-schema/inbox/operators/inboxGetters';
import { getInboxOptions } from 'conversations-thread-data/move-to-inbox/public/operators';
import { useCallback, useMemo } from 'react';
import { ROUTING_RULE_TYPES } from 'routing-ui/routing-rules/constants/RoutingTypes';
import { buildRoutingRulesFromType } from 'routing-ui/routing-rules/utils/buildRoutingRules';
import { jsx as _jsx } from "react/jsx-runtime";
export const MoveToInboxSelectInbox = ({
  currentInboxId,
  inboxData,
  loading,
  selectedInboxId,
  setShouldDisableRoutingRules,
  setRoutingRuleDefinition,
  setInbox,
  threadCurrentlyInHelpdesk,
  totalConversationsCount,
  isThreadFiltered
}) => {
  const haveMultipleConversationsOnTicket = Boolean(typeof totalConversationsCount === 'number' && totalConversationsCount > 1);
  const inboxOptions = useMemo(() => {
    const inboxesToInclude = !threadCurrentlyInHelpdesk && !isThreadFiltered ? inboxData : inboxData && inboxData.filter(inbox => !isInboxHelpdesk(inbox));
    return getInboxOptions(inboxesToInclude, currentInboxId);
  }, [currentInboxId, inboxData, threadCurrentlyInHelpdesk, isThreadFiltered]);
  const handleInboxOnChange = useCallback(evt => {
    if (inboxData === null) return;
    const selectedInbox = evt.target.value;
    const newlySelectedInbox = inboxData.find(ibx => ibx.id === selectedInbox);
    const disableRoutingRules = !!(newlySelectedInbox && isInboxHelpdesk(newlySelectedInbox) && haveMultipleConversationsOnTicket);
    const ruleType = disableRoutingRules ? ROUTING_RULE_TYPES.UNASSIGNED : ROUTING_RULE_TYPES.INBOX_USERS;
    setShouldDisableRoutingRules(disableRoutingRules);
    setRoutingRuleDefinition(buildRoutingRulesFromType(ruleType));
    setInbox(newlySelectedInbox);
  }, [inboxData, haveMultipleConversationsOnTicket, setInbox, setRoutingRuleDefinition, setShouldDisableRoutingRules]);
  return /*#__PURE__*/_jsx(UISelect, {
    "data-test-id": "move-to-inbox-select-inbox",
    disabled: loading,
    options: inboxOptions,
    value: selectedInboxId,
    onChange: handleInboxOnChange,
    placeholder: loading ? /*#__PURE__*/_jsx(LoadingSpinner, {}) : /*#__PURE__*/_jsx(FormattedMessage, {
      message: "conversations-thread-view.moveToInboxPrompt.inputPlaceholder"
    })
  });
};
MoveToInboxSelectInbox.displayName = 'MoveToInboxSelectInbox';
export default MoveToInboxSelectInbox;